/**
 * « Aurore de la Compagnie » (ADR 0031): Havrebourg's Company quarter, whose
 * emblem is a flame caught in ice, told as light. White and silver plate
 * with aurora reflections sliding from green to violet, a heart of light in
 * the breastplate, wings of aurora ribbons and a polar fox. Every piece is
 * animated like the founder's fire set: worn pieces drawn on the body, the
 * sword and the shield derived from their animated icons. Looks only.
 */
const PACK = 'aurora';
function look(id, name, slot, extra = {}) {
    return {
        id,
        lootable: false,
        cosmetic: true,
        name,
        kind: 'equipment',
        slot,
        rarity: 'legendary',
        sprite: `overlay.${id}`,
        icon: `icon.${id}`,
        ...extra,
    };
}
const templates = [
    look('aurora-sword', 'Épée de l’Aurore', 'weapon'),
    look('aurora-helm', 'Heaume de l’Aurore', 'helmet'),
    look('aurora-chest', 'Cuirasse de l’Aurore', 'chest'),
    look('aurora-gloves', 'Gantelets de l’Aurore', 'gloves'),
    look('aurora-boots', 'Bottes de l’Aurore', 'boots'),
    look('aurora-shield', 'Bouclier de l’Aurore', 'offhand', { classes: ['warrior'] }),
    look('aurora-wings', 'Ailes de l’Aurore', 'wings'),
    {
        id: 'aurora-fox',
        lootable: false,
        name: 'Renard polaire de l’Aurore',
        kind: 'equipment',
        slot: 'pet',
        rarity: 'legendary',
        companion: 'aurora-fox',
        icon: 'icon.aurora-fox',
    },
];
function single(id, name, blurb, priceCents) {
    return { id, name, blurb, pack: PACK, items: [{ templateId: id }], priceCents };
}
const singles = [
    single('aurora-sword', 'Épée de l’Aurore', 'Une lame d’argent blanc où glissent les reflets verts et violets de l’aurore. Animée.', 699),
    single('aurora-helm', 'Heaume de l’Aurore', 'Un heaume blanc et argent, un joyau de lumière au front, un panache d’aurore. Animé.', 599),
    single('aurora-chest', 'Cuirasse de l’Aurore', 'Plaques blanches et argent, un cœur de lumière qui brille au milieu de la poitrine. Animée.', 699),
    single('aurora-gloves', 'Gantelets de l’Aurore', 'Des poings d’argent blanc où passent les lueurs de l’aurore. Animés.', 399),
    single('aurora-boots', 'Bottes de l’Aurore', 'Des bottes d’argent blanc aux reflets verts et violets. Animées.', 399),
    single('aurora-shield', 'Bouclier de l’Aurore', 'Un écu blanc cerclé d’argent, la lumière au cœur, l’aurore sur sa face. Animé.', 599),
    single('aurora-wings', 'Ailes de l’Aurore', 'Deux rideaux de lumière qui ondulent dans ton dos, du vert au violet. Animées.', 999),
    single('aurora-fox', 'Renard polaire de l’Aurore', 'Un renard polaire au pelage blanc teinté d’aurore, qui trotte à ta droite. Animé.', 499),
];
const offers = [
    ...singles,
    {
        id: 'aurora-pack',
        name: 'Aurore de la Compagnie',
        blurb: 'La lumière de la Compagnie de Havrebourg : les six pièces d’argent blanc aux reflets d’aurore, les ailes de lumière et le renard polaire, par-dessus ton équipement.',
        pack: PACK,
        items: singles.map((offer) => ({ templateId: offer.id })),
        priceCents: 1999,
        worthCents: singles.reduce((sum, offer) => sum + offer.priceCents, 0),
    },
];
export const AURORA = { templates, offers };
//# sourceMappingURL=aurora.js.map